import { BrowserRouter, useRoutes } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import FormScreen from './screens/FormScreen';
import Success from './screens/Success';
import Error from './screens/Error';
import UserLost from './screens/UserLost';

const theme = createTheme({
  typography: {
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  },
  palette: {
    primary: {
      main: '#ff6600',
    },
  },
});

const Router = () =>
  useRoutes([
    { path: '/:businessId', element: <FormScreen /> },
    { path: '/error', element: <Error /> },
    { path: '/success', element: <Success /> },
    { path: '*', element: <UserLost /> },
  ]);

const App = () => (
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <Router />
    </ThemeProvider>
  </BrowserRouter>
);

export default App;
